import styled from "styled-components"

export const StatisticsContainer = styled.div`
  position: relative;
  .row {
    margin: 0;
    .col-lg-6 {
      padding: 0;
    }
  }
  .masthead {
    height: 500px;
    transition: 0.3s ease;
    @media (max-width: 1024x) {
      height: 400px;
    }
    @media (max-width: 991px) {
      height: 350px;
    }
    @media (max-width: 575px) {
      height: 250px;
    }
  }
  .title {
    h2 {
      text-align: center;
      color: #c6e5f4;
      position: absolute;
      z-index: 9;
      max-width: 750px;
      top: 150px;
      left: 50%;
      transform: translateX(-50%);
      transition: 0.3s ease;
      @media (max-width: 991px) {
        font-size: 30px;
        top: 80px;
      }
      @media (max-width: 575px) {
        position: relative;
        top: 0;
        color: ${props => props.theme.colors.darkBlue};
        padding: 0 15px;
        margin-bottom: 24px;
      }
    }
  }
`

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(198, 229, 244, 0),
    rgba(0, 65, 107, 1)
  );

  display: flex;
  align-items: flex-end;
  justify-content: center;

  .image-text {
    margin-bottom: 80px;
    p {
      color: ${props => props.theme.colors.white};
      text-align: center;
    }
  }
  @media (max-width: 575px) {
    align-items: center;
    .image-text {
      margin: 0;
    }
  }
`
